import { safeApiRequest } from './apiClient';

const DEVICES_ENDPOINT = '/api/devices';

/**
 * Cihaz payload'ını oluşturur
 * Backward compatibility: Hem urunId hem icerikId gönderiliyor
 */
const buildDevicePayload = (payload = {}) => {
  const data = {};

  if (payload.musteriId !== undefined && payload.musteriId !== null && payload.musteriId !== '') {
    data.musteriId = payload.musteriId;
  }

  // Backward compatibility: Hem urunId hem icerikId gönder
  // Backend'de Device modeli ya urunId ya da icerikId bekliyor olabilir
  const productId = payload.urunId || payload.icerikId;
  if (productId !== undefined && productId !== null && productId !== '') {
    data.urunId = productId; // Eski field (backward compatibility)
    data.icerikId = productId; // Yeni field (yeni yapı)
  }

  if (payload.seriNumarasi !== undefined && payload.seriNumarasi !== '') {
    data.seriNumarasi = String(payload.seriNumarasi).trim();
  }

  if (payload.garantiSuresi !== undefined && payload.garantiSuresi !== null && payload.garantiSuresi !== '') {
    // Garanti süresi ay cinsinden sayı olmalı
    data.garantiSuresi = parseInt(payload.garantiSuresi, 10);
  }

  // Kurulum tarihi (garanti başlangıç tarihi)
  if (payload.garantiBaslangicTarihi) {
    data.garantiBaslangicTarihi = payload.garantiBaslangicTarihi;
  }

  // Garanti bitiş tarihi (frontend'den hesaplanmış hali)
  if (payload.garantiBitisTarihi) {
    data.garantiBitisTarihi = payload.garantiBitisTarihi;
  }

  return data;
};

/**
 * Müşteriye ait cihazları getirir
 * @param {string} customerId - Müşteri ID
 * @param {Object} options - sayfa, limit, pasifDahil (müşteri yönetiminde pasif cihazları da göster)
 */
export const fetchDevicesByCustomer = async (customerId, { page = 1, limit = 50, pasifDahil = false } = {}) => {
  const customerIdStr = customerId ? String(customerId).trim() : '';
  if (!customerIdStr || customerIdStr === '') {
    throw new Error('Müşteri ID gereklidir');
  }

  const query = new URLSearchParams({ sayfa: page, limit });
  if (pasifDahil) query.set('pasifDahil', 'true');

  try {
    const response = await safeApiRequest(`${DEVICES_ENDPOINT}/musteri/${customerIdStr}?${query}`, {
      method: 'GET',
      skipCsrf: true,
    });
    return response;
  } catch (error) {
    console.error('[fetchDevicesByCustomer] Error:', error);
    throw error;
  }
};

/**
 * Cihaz oluştur
 */
export const createDevice = async (payload) => {
  const data = buildDevicePayload(payload);
  return safeApiRequest(DEVICES_ENDPOINT, {
    method: 'POST',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Cihaz güncelle
 */
export const updateDevice = async (id, payload) => {
  if (!id) {
    throw new Error('Cihaz ID gereklidir');
  }
  const data = buildDevicePayload(payload);
  return safeApiRequest(`${DEVICES_ENDPOINT}/${id}`, {
    method: 'PUT',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Cihaz sil
 */
export const deleteDevice = async (id) => {
  if (!id) {
    throw new Error('Cihaz ID gereklidir');
  }
  return safeApiRequest(`${DEVICES_ENDPOINT}/${id}`, {
    method: 'DELETE',
    skipCsrf: false,
  });
};



